import {call, put} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import BillingHistoryActions from '../Redux/BillingHistoryRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

// const fakeBillingHistory = {
//   count: 4,
//   next: null,
//   previous: null,
//   results: [
//     {
//       amount: 1513,
//       description: 'Pro plan - Annually',
//       id: 172,
//       issued: '2021-02-16',
//       monthly: false,
//       name: '6BDB95C6-0019',
//       services: [{amount: 108000, id: 138, plan: 'Pro', quantity: 1, service: 'Adspot Annually Subscription'}],
//       status: {id: 1, name: 'Paid'},
//       subscription: 2,
//       summary: {start: '2021-02-16', end: '2021-03-16'},
//     },
//     {
//       amount: 0,
//       description: 'Pro plan - Monthly',
//       id: 169,
//       issued: '2021-01-16',
//       monthly: true,
//       name: '6BDB95C6-0018',
//       services: [
//         {amount: -9999, id: 134, plan: null, quantity: 1, service: 'Unused time on Test pro after 16 Feb 2021'},
//         {amount: 0, id: 135, plan: 'Free', quantity: 1, service: 'Adspot Monthly Subscription'},
//       ],
//       status: {id: 3, name: 'Canceled'},
//       subscription: 2,
//       summary: {start: '2021-02-16', end: '2021-03-16'},
//     },
//     {
//       amount: 0,
//       description: 'Pro plan - Monthly',
//       id: 168,
//       issued: '2021-02-16',
//       monthly: true,
//       name: '6BDB95C6-0017',
//       services: [
//         {amount: -106490, id: 132, plan: null, quantity: 1, service: 'Unused time on Pro Plan after 16 Feb 2021'},
//         {amount: 10000, id: 133, plan: 'Pro', quantity: 1, service: 'Adspot Monthly Subscription'},
//       ],
//       status: {id: 1, name: 'Paid'},
//       subscription: 2,
//       summary: {start: '2021-02-16', end: '2021-03-15'},
//     },
//     {
//       amount: 0,
//       description: 'Pro plan - Monthly',
//       id: 178,
//       issued: '2021-02-16',
//       monthly: true,
//       name: '6BDB95C6-0027',
//       services: [
//         {amount: -106490, id: 132, plan: null, quantity: 1, service: 'Unused time on Pro Plan after 16 Feb 2021'},
//         {amount: 10000, id: 133, plan: 'Pro', quantity: 1, service: 'Adspot Monthly Subscription'},
//       ],
//       status: {id: 1, name: 'Paid'},
//       subscription: 2,
//       summary: {start: '2021-02-06', end: '2021-03-06'},
//     },
//   ],
// }

export function* getBillingHistory(api, authApi, {page, page_size, id}) {
  try {
    const response = yield call(api.getBillingHistory, page, page_size, id)
    if (response && response.ok) {
      yield put(BillingHistoryActions.billingHistorySuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(BillingHistoryActions.billingHistoryFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getBillingHistory(api, authApi, {page, page_size, id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(BillingHistoryActions.billingHistoryFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
